// extracted by mini-css-extract-plugin
export var pillWrapper = "_mr-0";
export var showOverflow = "_mr-1";